/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CoaAccountDTO,
  CoaDTO,
  CountCoasParams,
  FixedDepositSettingDTO,
  GetAllCoasParams,
  GetFxDSettingParams,
  GetGlAccountsParams,
  MapType,
  SearchByAcNameParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAllCoas = (
    params: GetAllCoasParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaDTO[]>(
      {url: `/api/coas`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAllCoasQueryKey = (params?: GetAllCoasParams,) => {
    return [`/api/coas`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAllCoasQueryOptions = <TData = Awaited<ReturnType<typeof getAllCoas>>, TError = unknown>(params: GetAllCoasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCoas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllCoasQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCoas>>> = ({ signal }) => getAllCoas(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCoas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllCoasQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCoas>>>
export type GetAllCoasQueryError = unknown


export function useGetAllCoas<TData = Awaited<ReturnType<typeof getAllCoas>>, TError = unknown>(
 params: GetAllCoasParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCoas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCoas>>,
          TError,
          Awaited<ReturnType<typeof getAllCoas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCoas<TData = Awaited<ReturnType<typeof getAllCoas>>, TError = unknown>(
 params: GetAllCoasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCoas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCoas>>,
          TError,
          Awaited<ReturnType<typeof getAllCoas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCoas<TData = Awaited<ReturnType<typeof getAllCoas>>, TError = unknown>(
 params: GetAllCoasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCoas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllCoas<TData = Awaited<ReturnType<typeof getAllCoas>>, TError = unknown>(
 params: GetAllCoasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCoas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllCoasQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateCoa = (
    coaDTO: CoaDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CoaDTO>(
      {url: `/api/coas`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: coaDTO
    },
      options);
    }
  


export const getUpdateCoaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCoa>>, TError,{data: CoaDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCoa>>, TError,{data: CoaDTO}, TContext> => {

const mutationKey = ['updateCoa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCoa>>, {data: CoaDTO}> = (props) => {
          const {data} = props ?? {};

          return  updateCoa(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCoaMutationResult = NonNullable<Awaited<ReturnType<typeof updateCoa>>>
    export type UpdateCoaMutationBody = CoaDTO
    export type UpdateCoaMutationError = unknown

    export const useUpdateCoa = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCoa>>, TError,{data: CoaDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCoa>>,
        TError,
        {data: CoaDTO},
        TContext
      > => {

      const mutationOptions = getUpdateCoaMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const createCoa = (
    coaDTO: CoaDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaDTO>(
      {url: `/api/coas`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: coaDTO, signal
    },
      options);
    }
  


export const getCreateCoaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCoa>>, TError,{data: CoaDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCoa>>, TError,{data: CoaDTO}, TContext> => {

const mutationKey = ['createCoa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCoa>>, {data: CoaDTO}> = (props) => {
          const {data} = props ?? {};

          return  createCoa(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCoaMutationResult = NonNullable<Awaited<ReturnType<typeof createCoa>>>
    export type CreateCoaMutationBody = CoaDTO
    export type CreateCoaMutationError = unknown

    export const useCreateCoa = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCoa>>, TError,{data: CoaDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCoa>>,
        TError,
        {data: CoaDTO},
        TContext
      > => {

      const mutationOptions = getCreateCoaMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getCoa = (
    glNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaDTO>(
      {url: `/api/coas/${glNo}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCoaQueryKey = (glNo?: string,) => {
    return [`/api/coas/${glNo}`] as const;
    }

    
export const getGetCoaQueryOptions = <TData = Awaited<ReturnType<typeof getCoa>>, TError = unknown>(glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoa>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCoaQueryKey(glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoa>>> = ({ signal }) => getCoa(glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoa>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCoaQueryResult = NonNullable<Awaited<ReturnType<typeof getCoa>>>
export type GetCoaQueryError = unknown


export function useGetCoa<TData = Awaited<ReturnType<typeof getCoa>>, TError = unknown>(
 glNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoa>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoa>>,
          TError,
          Awaited<ReturnType<typeof getCoa>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCoa<TData = Awaited<ReturnType<typeof getCoa>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoa>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCoa>>,
          TError,
          Awaited<ReturnType<typeof getCoa>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCoa<TData = Awaited<ReturnType<typeof getCoa>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoa>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCoa<TData = Awaited<ReturnType<typeof getCoa>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoa>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCoaQueryOptions(glNo,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const deleteCoa = (
    glNo: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<null>(
      {url: `/api/coas/${glNo}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCoaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoa>>, TError,{glNo: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCoa>>, TError,{glNo: string}, TContext> => {

const mutationKey = ['deleteCoa'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCoa>>, {glNo: string}> = (props) => {
          const {glNo} = props ?? {};

          return  deleteCoa(glNo,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCoaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCoa>>>
    
    export type DeleteCoaMutationError = unknown

    export const useDeleteCoa = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCoa>>, TError,{glNo: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCoa>>,
        TError,
        {glNo: string},
        TContext
      > => {

      const mutationOptions = getDeleteCoaMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const coasSettings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaDTO[]>(
      {url: `/api/coas/settings`, method: 'GET', signal
    },
      options);
    }
  

export const getCoasSettingsQueryKey = () => {
    return [`/api/coas/settings`] as const;
    }

    
export const getCoasSettingsQueryOptions = <TData = Awaited<ReturnType<typeof coasSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coasSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoasSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coasSettings>>> = ({ signal }) => coasSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coasSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CoasSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof coasSettings>>>
export type CoasSettingsQueryError = unknown


export function useCoasSettings<TData = Awaited<ReturnType<typeof coasSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof coasSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof coasSettings>>,
          TError,
          Awaited<ReturnType<typeof coasSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCoasSettings<TData = Awaited<ReturnType<typeof coasSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coasSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof coasSettings>>,
          TError,
          Awaited<ReturnType<typeof coasSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCoasSettings<TData = Awaited<ReturnType<typeof coasSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coasSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCoasSettings<TData = Awaited<ReturnType<typeof coasSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coasSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCoasSettingsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const searchByAcName = (
    params: SearchByAcNameParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaDTO[]>(
      {url: `/api/coas/search-by-name`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSearchByAcNameQueryKey = (params?: SearchByAcNameParams,) => {
    return [`/api/coas/search-by-name`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchByAcNameQueryOptions = <TData = Awaited<ReturnType<typeof searchByAcName>>, TError = unknown>(params: SearchByAcNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByAcName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchByAcNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchByAcName>>> = ({ signal }) => searchByAcName(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchByAcName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchByAcNameQueryResult = NonNullable<Awaited<ReturnType<typeof searchByAcName>>>
export type SearchByAcNameQueryError = unknown


export function useSearchByAcName<TData = Awaited<ReturnType<typeof searchByAcName>>, TError = unknown>(
 params: SearchByAcNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByAcName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchByAcName>>,
          TError,
          Awaited<ReturnType<typeof searchByAcName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchByAcName<TData = Awaited<ReturnType<typeof searchByAcName>>, TError = unknown>(
 params: SearchByAcNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByAcName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchByAcName>>,
          TError,
          Awaited<ReturnType<typeof searchByAcName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchByAcName<TData = Awaited<ReturnType<typeof searchByAcName>>, TError = unknown>(
 params: SearchByAcNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByAcName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchByAcName<TData = Awaited<ReturnType<typeof searchByAcName>>, TError = unknown>(
 params: SearchByAcNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchByAcName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchByAcNameQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const findByOrderByGlNoAsc = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaDTO[]>(
      {url: `/api/coas/ordered`, method: 'GET', signal
    },
      options);
    }
  

export const getFindByOrderByGlNoAscQueryKey = () => {
    return [`/api/coas/ordered`] as const;
    }

    
export const getFindByOrderByGlNoAscQueryOptions = <TData = Awaited<ReturnType<typeof findByOrderByGlNoAsc>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByOrderByGlNoAsc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindByOrderByGlNoAscQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findByOrderByGlNoAsc>>> = ({ signal }) => findByOrderByGlNoAsc(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findByOrderByGlNoAsc>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type FindByOrderByGlNoAscQueryResult = NonNullable<Awaited<ReturnType<typeof findByOrderByGlNoAsc>>>
export type FindByOrderByGlNoAscQueryError = unknown


export function useFindByOrderByGlNoAsc<TData = Awaited<ReturnType<typeof findByOrderByGlNoAsc>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByOrderByGlNoAsc>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findByOrderByGlNoAsc>>,
          TError,
          Awaited<ReturnType<typeof findByOrderByGlNoAsc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindByOrderByGlNoAsc<TData = Awaited<ReturnType<typeof findByOrderByGlNoAsc>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByOrderByGlNoAsc>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findByOrderByGlNoAsc>>,
          TError,
          Awaited<ReturnType<typeof findByOrderByGlNoAsc>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useFindByOrderByGlNoAsc<TData = Awaited<ReturnType<typeof findByOrderByGlNoAsc>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByOrderByGlNoAsc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useFindByOrderByGlNoAsc<TData = Awaited<ReturnType<typeof findByOrderByGlNoAsc>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findByOrderByGlNoAsc>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getFindByOrderByGlNoAscQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getLeafNodesWithoutSpecificProducts = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaDTO[]>(
      {url: `/api/coas/leaf-nodes`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLeafNodesWithoutSpecificProductsQueryKey = () => {
    return [`/api/coas/leaf-nodes`] as const;
    }

    
export const getGetLeafNodesWithoutSpecificProductsQueryOptions = <TData = Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeafNodesWithoutSpecificProductsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>> = ({ signal }) => getLeafNodesWithoutSpecificProducts(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLeafNodesWithoutSpecificProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>>
export type GetLeafNodesWithoutSpecificProductsQueryError = unknown


export function useGetLeafNodesWithoutSpecificProducts<TData = Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>,
          TError,
          Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLeafNodesWithoutSpecificProducts<TData = Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>,
          TError,
          Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLeafNodesWithoutSpecificProducts<TData = Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLeafNodesWithoutSpecificProducts<TData = Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithoutSpecificProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLeafNodesWithoutSpecificProductsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getLeafNodesWithGlProductAcFs = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaDTO[]>(
      {url: `/api/coas/leaf-nodes-gl-product-ac-fs`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLeafNodesWithGlProductAcFsQueryKey = () => {
    return [`/api/coas/leaf-nodes-gl-product-ac-fs`] as const;
    }

    
export const getGetLeafNodesWithGlProductAcFsQueryOptions = <TData = Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeafNodesWithGlProductAcFsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>> = ({ signal }) => getLeafNodesWithGlProductAcFs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLeafNodesWithGlProductAcFsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>>
export type GetLeafNodesWithGlProductAcFsQueryError = unknown


export function useGetLeafNodesWithGlProductAcFs<TData = Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>,
          TError,
          Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLeafNodesWithGlProductAcFs<TData = Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>,
          TError,
          Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLeafNodesWithGlProductAcFs<TData = Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLeafNodesWithGlProductAcFs<TData = Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeafNodesWithGlProductAcFs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLeafNodesWithGlProductAcFsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getLastCoa = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaDTO>(
      {url: `/api/coas/last`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLastCoaQueryKey = () => {
    return [`/api/coas/last`] as const;
    }

    
export const getGetLastCoaQueryOptions = <TData = Awaited<ReturnType<typeof getLastCoa>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastCoa>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLastCoaQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastCoa>>> = ({ signal }) => getLastCoa(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLastCoa>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLastCoaQueryResult = NonNullable<Awaited<ReturnType<typeof getLastCoa>>>
export type GetLastCoaQueryError = unknown


export function useGetLastCoa<TData = Awaited<ReturnType<typeof getLastCoa>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastCoa>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLastCoa>>,
          TError,
          Awaited<ReturnType<typeof getLastCoa>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLastCoa<TData = Awaited<ReturnType<typeof getLastCoa>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastCoa>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLastCoa>>,
          TError,
          Awaited<ReturnType<typeof getLastCoa>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLastCoa<TData = Awaited<ReturnType<typeof getLastCoa>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastCoa>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLastCoa<TData = Awaited<ReturnType<typeof getLastCoa>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastCoa>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLastCoaQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFxDSetting = (
    params: GetFxDSettingParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FixedDepositSettingDTO>(
      {url: `/api/coas/fixed-deposit`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetFxDSettingQueryKey = (params?: GetFxDSettingParams,) => {
    return [`/api/coas/fixed-deposit`, ...(params ? [params]: [])] as const;
    }

    
export const getGetFxDSettingQueryOptions = <TData = Awaited<ReturnType<typeof getFxDSetting>>, TError = unknown>(params: GetFxDSettingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFxDSetting>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFxDSettingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFxDSetting>>> = ({ signal }) => getFxDSetting(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFxDSetting>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFxDSettingQueryResult = NonNullable<Awaited<ReturnType<typeof getFxDSetting>>>
export type GetFxDSettingQueryError = unknown


export function useGetFxDSetting<TData = Awaited<ReturnType<typeof getFxDSetting>>, TError = unknown>(
 params: GetFxDSettingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFxDSetting>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFxDSetting>>,
          TError,
          Awaited<ReturnType<typeof getFxDSetting>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFxDSetting<TData = Awaited<ReturnType<typeof getFxDSetting>>, TError = unknown>(
 params: GetFxDSettingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFxDSetting>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFxDSetting>>,
          TError,
          Awaited<ReturnType<typeof getFxDSetting>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFxDSetting<TData = Awaited<ReturnType<typeof getFxDSetting>>, TError = unknown>(
 params: GetFxDSettingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFxDSetting>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFxDSetting<TData = Awaited<ReturnType<typeof getFxDSetting>>, TError = unknown>(
 params: GetFxDSettingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFxDSetting>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFxDSettingQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDefineProduct = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaDTO[]>(
      {url: `/api/coas/define-product`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDefineProductQueryKey = () => {
    return [`/api/coas/define-product`] as const;
    }

    
export const getGetDefineProductQueryOptions = <TData = Awaited<ReturnType<typeof getDefineProduct>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefineProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefineProductQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefineProduct>>> = ({ signal }) => getDefineProduct(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDefineProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDefineProductQueryResult = NonNullable<Awaited<ReturnType<typeof getDefineProduct>>>
export type GetDefineProductQueryError = unknown


export function useGetDefineProduct<TData = Awaited<ReturnType<typeof getDefineProduct>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefineProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefineProduct>>,
          TError,
          Awaited<ReturnType<typeof getDefineProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDefineProduct<TData = Awaited<ReturnType<typeof getDefineProduct>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefineProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefineProduct>>,
          TError,
          Awaited<ReturnType<typeof getDefineProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDefineProduct<TData = Awaited<ReturnType<typeof getDefineProduct>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefineProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDefineProduct<TData = Awaited<ReturnType<typeof getDefineProduct>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefineProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDefineProductQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const countCoas = (
    params: CountCoasParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/coas/count`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCountCoasQueryKey = (params?: CountCoasParams,) => {
    return [`/api/coas/count`, ...(params ? [params]: [])] as const;
    }

    
export const getCountCoasQueryOptions = <TData = Awaited<ReturnType<typeof countCoas>>, TError = unknown>(params: CountCoasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countCoas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountCoasQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof countCoas>>> = ({ signal }) => countCoas(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countCoas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CountCoasQueryResult = NonNullable<Awaited<ReturnType<typeof countCoas>>>
export type CountCoasQueryError = unknown


export function useCountCoas<TData = Awaited<ReturnType<typeof countCoas>>, TError = unknown>(
 params: CountCoasParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countCoas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countCoas>>,
          TError,
          Awaited<ReturnType<typeof countCoas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountCoas<TData = Awaited<ReturnType<typeof countCoas>>, TError = unknown>(
 params: CountCoasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countCoas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countCoas>>,
          TError,
          Awaited<ReturnType<typeof countCoas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCountCoas<TData = Awaited<ReturnType<typeof countCoas>>, TError = unknown>(
 params: CountCoasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countCoas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCountCoas<TData = Awaited<ReturnType<typeof countCoas>>, TError = unknown>(
 params: CountCoasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countCoas>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCountCoasQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGlAccounts = (
    mapType: MapType,
    params?: GetGlAccountsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaAccountDTO[]>(
      {url: `/api/coas/accounts/${mapType}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetGlAccountsQueryKey = (mapType?: MapType,
    params?: GetGlAccountsParams,) => {
    return [`/api/coas/accounts/${mapType}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetGlAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getGlAccounts>>, TError = unknown>(mapType: MapType,
    params?: GetGlAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGlAccountsQueryKey(mapType,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGlAccounts>>> = ({ signal }) => getGlAccounts(mapType,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(mapType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGlAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGlAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getGlAccounts>>>
export type GetGlAccountsQueryError = unknown


export function useGetGlAccounts<TData = Awaited<ReturnType<typeof getGlAccounts>>, TError = unknown>(
 mapType: MapType,
    params: undefined |  GetGlAccountsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlAccounts>>,
          TError,
          Awaited<ReturnType<typeof getGlAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGlAccounts<TData = Awaited<ReturnType<typeof getGlAccounts>>, TError = unknown>(
 mapType: MapType,
    params?: GetGlAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlAccounts>>,
          TError,
          Awaited<ReturnType<typeof getGlAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGlAccounts<TData = Awaited<ReturnType<typeof getGlAccounts>>, TError = unknown>(
 mapType: MapType,
    params?: GetGlAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetGlAccounts<TData = Awaited<ReturnType<typeof getGlAccounts>>, TError = unknown>(
 mapType: MapType,
    params?: GetGlAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGlAccountsQueryOptions(mapType,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



